import { formatDateSafe } from '@/utils/dateUtils';
import { computeReturnDate } from '../../../utils/vacationRules';
import { SEGMENT_SUMMARY_HEADERS } from '../vacationRequestForm.definitions';
import type { VacationSegment } from '../../../models/vacation.types';

export interface VacationSegmentsSummaryProps {
    segments: VacationSegment[];
    totalDays: number;
}

export function VacationSegmentsSummary({ segments, totalDays }: VacationSegmentsSummaryProps) {
    if (segments.length === 0) {
        return (
            <div className="rounded-lg p-4 text-center text-sm text-raro-gray-500 font-montserrat">
                —
            </div>
        );
    }

    return (
        <div className="overflow-x-auto shadow ring-1 ring-black ring-opacity-5 rounded-lg">
            <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                            {SEGMENT_SUMMARY_HEADERS.period}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            {SEGMENT_SUMMARY_HEADERS.days}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            {SEGMENT_SUMMARY_HEADERS.start}
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            {SEGMENT_SUMMARY_HEADERS.returnDate}
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                    {segments.map((segment) => (
                        <tr key={segment.order}>
                            <td className="whitespace-nowrap py-4 pl-4 pr-3 sm:pl-6">
                                <span className="inline-flex items-center rounded-md bg-primary-600 px-2 py-0.5 text-xs font-semibold text-white">
                                    {segment.order}º
                                </span>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4">
                                <span className="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
                                    {segment.days} dias
                                </span>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-raro-gray-900 font-montserrat">
                                {formatDateSafe(segment.startDate)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-raro-gray-900 font-montserrat">
                                {formatDateSafe(computeReturnDate(segment.startDate, segment.days))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default VacationSegmentsSummary;
